Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.validationApiMethodType = "GET";
exports.apiMethodTypeAddDetail = "POST";

exports.urlGetValidations = "profile/validations";
exports.errorEmailNotValid = "Email not valid.";
exports.validationApiContentType = "application/json";


exports.contentTypeApiAddDetail = "application/json";
exports.accountsAPiEndPoint = "account/accounts";
exports.httpGetMethod = "GET"
exports.httpPostMethod = "POST"
exports.httpPutMethod = "PUT"
exports.createUserAccountApiEndPoint = "account_block/accounts"
exports.emailVerificationApiEndPoint = "account_block/accounts/verify_account"
exports.sendPhonOtpApiEndPoint = "bx_block_forgot_password/send_verification_code"
exports.verifyPhonOtpApiEndPoint = "bx_block_forgot_password/verify_otp"
exports.emailVerificationLinkApiEndPoint = "account_block/accounts/resend_verification_email"

exports.placeHolderEmail = "Email";

exports.labelHeader = "Value proposition: why users should sign up.";
exports.labelFirstName = "First name";
exports.lastName = "Last name";
exports.labelEmail = "Email";
exports.invalidOtpText = "Invalid OTP"
exports.labelPassword = "Password";
exports.labelRePassword = "Re-Type Password";
exports.errorCountryCodeNotSelected = "Please select country code";
exports.errorBlankField = "can't be blank";

exports.labelLegalText = "Legal text: By signing up you agree to our Terms &amp; conditions and Privacy policy.";

exports.labelLegalTermCondition = "Terms and conditions";
exports.labelLegalPrivacyPolicy = "Privacy policy";
exports.btnTextSignUp = "Sign up";
exports.errorPasswordNotValid = "Password not valid.";

exports.errorTitle = "Error";

exports.errorBothPasswordsNotSame = "Passwords should be same.";
exports.errorAllFieldsAreMandatory = "All fields are mandatory.";

exports.EMAIL_VERIFICATION_TOKEN = "token"
exports.verifyText = "Verify"
exports.verifiedText = "Verified"
exports.submitText = "Submit"
exports.signUpText = "Sign Up"
exports.resendOtpText = "Resend OTP"
exports.contactUsText = "Contact Us"
exports.signingUpThankYouText = "Thank you for signing up!"
exports.resendActivationLinkText = "Resend Activation Link"
exports.accountVerifiedText = "Account Verified Successfully!"
exports.signUpCompleteDescriptionFirst = "An activation link has been sent to your email address ("
exports.signUpCompleteDescriptionSecond = "). Please check your inbox and click on the link to verify your email and reset your password. If you don't see the email, please check your spam or junk folder. For any issues, contact our support team."
// Customizable Area End
